<div id='eFormId' class="form-container">
  <form name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm">
    <div class="spinner-overlay" *ngIf="cargandoDatos || onSubmitProcess">
      <div class="spinner-center">
        <mat-spinner *ngIf="cargandoDatos || onSubmitProcess" diameter="80" color="primary"></mat-spinner>
        <label class="input-label" *ngIf="cargandoDatos">&nbsp; Cargando datos...</label>
      </div>
    </div>

    <button *ngIf="!cargandoDatos && !onSuccess && !onError && fromMenu" type="button"
      (click)="switchAssistantHandler()"
      style="border-radius: 0px; text-align: left; width: 100%; background-color: #013B82;box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0),0 2px 2px 0 rgba(0, 0, 0, 0),0 1px 5px 0 rgba(0, 0, 0, 0);"
      mat-raised-button color="primary" class="boton-volver difuminador">
      <i class="material-icons mr-1 f-15" style="vertical-align: middle;">arrow_back</i><span
        style="font-size: 13px; font-family: Roboto,'Helvetica Neue',sans-serif;color: white; cursor: pointer">Elegir
        otro tema del menú</span>
    </button>
    <!--
    <div class="example-headers-align">

      <div *ngIf="!codigoTema && !cargandoDatos && !onSuccess && !onError" style="margin: 10px;">
        <div style="height: 100%;">
          <h4 style="font-family: Roboto,'Helvetica Neue',sans-serif; margin-right: 10px;">¿Necesitas ayuda?</h4>
          <p style="margin-right: 10px ;font: 400 14px/20px Roboto,'Helvetica Neue',sans-serif">Elige el tema sobre el
            que deseas consultar.</p>
          <ul style="color: #365780" *ngFor="let t of temasAsociados">
            <li class="temaClass"><span title="{{ t.descripcion }}"
                style="font-family: Roboto,'Helvetica Neue',sans-serif; font-size: 14px;font-weight: bold ;color: #365780; cursor: pointer; border-radius: 2px;"
                (click)="seleccionarTema(t.codigo,t.titulo)">{{ t.titulo }}</span>
            </li>
          </ul>
        </div>
      </div>

    </div>
  -->

    <!-- <div
      *ngIf="codigoTema && (formElements.datosEmpresa || formElements.datosObra) && !cargandoDatos && !onSuccess && !onError"
      style="margin: 10px;"> -->
    <div *ngIf="codigoTema && !cargandoDatos && !onSuccess && !onError" style="margin: 10px;">

      <div *ngIf="codigoTema">
        <div appearance="fill">
          <h4 *ngIf="!ctx.esFormulario && ctx.idMenu"
            style="font-size: 22px; font-family: Roboto,'Helvetica Neue',sans-serif;">Tema de la consulta:
            {{etiquetaNodoArbol}}</h4>
          <h4 *ngIf="ctx.esFormulario || !ctx.idMenu"
            style="font-size: 22px; font-family: Roboto,'Helvetica Neue',sans-serif;">Envia tu consulta
          </h4>

          <div style="border: 1px solid #ced4da;border-radius: 0.25rem;">
            <textarea character-set="utf-8" maxlength="600" class="form-control" matInput name="consulta"
              [(ngModel)]="consulta"
              style="font-family: Roboto,'Helvetica Neue',sans-serif;width: 93%; min-height: 190px;overflow:hidden"
              placeholder="Escribe aquí tu consulta ..." #consultaF="ngModel" required></textarea>
            <div>

              <table style="width: 100%; ">
                <tr>
                  <td style="text-align: right;">
                    <input class="attach-inputfile" type="file" multiple (change)="attachFiles($event)"
                      id="id_attachment" />
                    <label for="id_attachment"
                      style="color:grey; background-color: white; border: 0px solid white;text-align: center;">
                      <i title="Puedes adjuntar hasta 4 archivos que, en total, no superen los 2 MB."
                        class="material-icons f-22 mb-1" style="background-color: white;">attachment</i>
                      <span style="font-family: Roboto,'Helvetica Neue',sans-serif; font-size: 11px;">Adjuntar</span>
                    </label>
                  </td>
                </tr>
              </table>

              <div [@fadeInAndOut] *ngIf="attachments.length >0">
                <table class="attach_table">
                  <tr [@fadeInAndOut] *ngFor="let file of attachments" class="attach_table_data">
                    <td><span style="background-color: #f8f9fa;border-radius: 2px; "> 📄​ {{ file.name }} <b
                          style="cursor: pointer; " (click)="elimiarAdjunto(file.name)">x</b></span></td>
                  </tr>
                </table>

              </div>
            </div>
          </div>
          <div> <span style="font-size: 11px; float: right;font-family: Roboto,'Helvetica Neue',sans-serif">Máximo 600
              caracteres.</span></div>
          <div *ngIf="f.submitted && consultaF.invalid" class="validationClass">
            <div *ngIf="consultaF.errors.required">Debe ingresar la consulta</div>
          </div>
        </div>

        <div>
          <div class="validationClass" role="alert">{{ attachmentsErrorMessage }}</div>
          <br />
        </div>
        <!-- Escenario 1.a: se pudo cargar solo el email registrado (finalidad =20)-->
        <div *ngIf="email && !emailOperativo">
          <span style="font-family: Roboto,'Helvetica Neue',sans-serif; font-size: 14px;">La respuesta será enviada a:
            <b>{{email}}</b> </span>
        </div>
        <!-- Esceneario 1.b se pudo cargar solo el emailOperativo-->
        <div *ngIf="!email && emailOperativo">
          <span style="font-family: Roboto,'Helvetica Neue',sans-serif; font-size: 14px;">La respuesta será enviada a la
            casilla de correo que tiene registrada. </span>
        </div>
        <!-- Escenario 2: es empresa y se pudo cargar email registrado y el operativo -->
        <div *ngIf="email && emailOperativo">
          <span style="font-family: Roboto,'Helvetica Neue',sans-serif; font-size: 14px;">Elija la dirección de correo
            en la que desea recibir la respuesta:
          </span>
          <br /><br />
          <mat-radio-group style="display: grid;" [(ngModel)]="emailDeContacto" [ngModelOptions]="{standalone: true}">
            <span
              style="font-family: Roboto,'Helvetica Neue',sans-serif; font-size: 14px; margin-bottom: 5px;"><b>Correo
                del usuario personal BPS </b>
              <div class="tooltip"><img src="assets/images/question_mark_blue.gif" style="cursor: pointer;"><span
                  class="tooltiptext">Para actualizarlo, ingrese a «Modificar mis datos».</span></div>
            </span>

            <mat-radio-button [value]="email" style="margin-bottom: 10px;"><span
                style="font-family: Roboto,'Helvetica Neue',sans-serif; font-size: 14px;">{{email}}</span></mat-radio-button>

            <br />
            <span
              style="font-family: Roboto,'Helvetica Neue',sans-serif; font-size: 14px; margin-bottom: 5px;"><b>Correo de
                contacto de la empresa </b>
              <div class="tooltip"><img src="assets/images/question_mark_blue.gif" style="cursor: pointer;"><span
                  class="tooltiptext">Para actualizarlo, ingrese al servicio «Ingresar y modificar datos de contacto de
                  empresas».</span></div>
            </span>
            <mat-radio-button [value]="emailOperativo"><span
                style="font-family: Roboto,'Helvetica Neue',sans-serif; font-size: 14px;">{{emailOperativo}}</span></mat-radio-button>
          </mat-radio-group>
        </div>
        <!-- Escenario 3: No fue posible cargar ningun email se envia por defecto al conacto (finalidad 20)-->
        <div *ngIf="!email && !emailOperativo">
          <span style="font-family: Roboto,'Helvetica Neue',sans-serif; font-size: 12px;">La respuesta será enviada a la
            casilla de correo que tiene registrada. </span>
        </div>

        <br />
        <div>
          <div style="text-align: end;">
            <button style="width: 100%; height: 100%; border-radius: 2px; min-height: 50px;" type="submit"
              mat-raised-button class="btn-class">
              <i class="material-icons f-32 mr-3">mail_outline</i>
              <b> Enviar Consulta</b></button>
          </div>
        </div>


      </div>

    </div>

    <!-- Seccion consulta enviadasatisfactoriamente -->
    <div *ngIf="!cargandoDatos && onSuccess" class="card-body" style="margin: 15px;">
      <br /><br />
      <div class="alert alert-success py-3 align-items-start text-body" role="alert">
        <i class="material-icons text-success">check_circle</i>
        <span>
          <h5 class="lh-title" style="margin: 0px;">¡Se ha enviado tu consulta!</h5>
          <br />
          <span *ngIf="email && !emailOperativo && emailDeContacto" style="font-weight: normal;">Recibirás la respuesta
            a la dirección de correo asociada a tu
            usuario: {{emailDeContacto}}</span>

          <span *ngIf="email && emailOperativo && emailDeContacto" style="font-weight: normal;">Recibirás la respuesta a
            la dirección de correo seleccionada:
            {{emailDeContacto}}</span>

          <span *ngIf="!emailDeContacto" style="font-weight: normal;">Recibirás la respuesta a la dirección de correo
            asociada a
            tu usuario.</span>

        </span>

      </div>
    </div>

    <!-- Seccion de error-->
    <div *ngIf="!cargandoDatos && onError" class="card-body" style="margin: 15px;">
      <br /><br />
      <div class="alert alert-danger py-3 align-items-start" role="alert">
        <i class="material-icons text-danger">error</i>
        <span>
          <h5 class="lh-title" style="margin: 0px;">Se ha producido un error</h5>
          <br />
          <span style="font-weight: normal;">Lamentamos el inconveniente. </span><br /><span
            style="font-weight: normal;">Por favor, cierra la ventana de asistencia e ingresá nuevamente tu
            consulta.</span>
        </span>
        <br />
      </div>
    </div>

    <div>


    </div>

  </form>
</div>